import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { AuthContext } from '../context';

export default function noAuthRequired(WrappedComponent) {
  class Authentication extends Component {
    static contextType = AuthContext;

    render() {
      if (this.context.isAuthenticated) {
        return <Redirect to='/home' />;
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  return Authentication;
}
